// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__aDMez","hand":"Home_hand__989LL","wave":"Home_wave__IyLHv"};